@if (ui<2 || forceMenuButton) {
  @if (isMenuShown) {
    <div aria-haspopup="true" [attr.aria-expanded]="isOpen" [ngClass]="{menubutton:buttonIconSize>=0,compare: isCompare, menuonly:buttonIconSize<0, open:isOpen, crumby:buttonIconSize===3, mobile:ui>=2, oai:isAddin, border:isOnDialog, admin:menuID===54}" (click)="toggleMenuOpen($event)" (keyup.enter)="toggleMenuOpen($event)" (keyup.arrowdown)="!isOpen?toggleMenuOpen($event):null" (keyup.arrowup)="isOpen?toggleMenuOpen($event):null" (keydown.space)="toggleMenuOpen($event)" (keydown.shift.tab)="closeMenuOnFocusOut(-2)">
      @if (!!buttonIcon) {
        <img [id]="id" [role]="getMenuRole()" [tabindex]="tabIndex" src="{{isOpen ? buttonIconOpen : buttonIcon}}" [ngClass]="{mini:buttonIconSize===1||buttonIconSize===-1, maxi:buttonIconSize===2||buttonIconSize===-2, crumby:buttonIconSize===3}" alt="{{toolTip}}" title="{{toolTip}}" (keyup)="onKeyUp($event)" [attr.aria-label]="getMenuAriaLabel()" (keydown)="onKeyDown($event)">
      }
      @if (!buttonIcon) {
        <div [role]="getMenuRole()" [attr.aria-label]="getMenuAriaLabel()" [tabindex]="tabIndex" class="noimg" [ngClass]="{usermenu:menuID===7}"></div>
      }
    </div>
  }
  @if (isOpen) {
    <div class="menu-overlay" (click)="overlayClick($event)"></div>
  }
  @if (isOpen) {
    <ul #ul role="menu" [ngClass]="{opening:isOpening, closing:isClosing, drawright:drawToRight, allowchecks:allowChecks, drawup:drawUp, mini:buttonIconMini, wide:wide, noselect:noSelect, oai:isAddin, crumby:buttonIconSize===3, indialog:isOnDialog&&ui<2}" [style.maxHeight]="ulMaxHeight" (animationend)="transitionComplete()">
      @for (item of items; track item; let i = $index) {
        <li role="none" [ngClass]="{separator:item.separator, edx_hidden:!item.enabled, button:item.button, heading:item.heading, indialog:isOnDialog}" (keyup)="onKeyUp($event,i)" (keydown.shift.tab)="onKeyUp($event,i)">
          <div class="item-container">
            @if (item.checkable) {
              <div role="none" class="checkmark" [ngClass]="{checked:item.checked, safari:safari||officeAddinDesktopMac}" (click)="toggleCheck(i, $event)" (keyup.enter)="toggleCheck(i, $event)" (keydown.space)="toggleCheck(i, $event)"></div>
            }
            @if (!item.button && !item.heading) {
              <div [attr.role]="item.checkable?'menuitemcheckbox':'menuitem'" [attr.aria-checked]="item.checkable?item.checked:none" class="menu-text" id="{{getMenuId(item)}}" [attr.aria-label]="isChrome?(item.checked?item.name:item.name+' '):item.name" [tabindex]="item.separator ? -1 :tabIndex" (click)="doCommand(i, $event)" (keyup.enter)="doCommand(i, $event)" (keydown.space)="doCommand(i, $event)" (focusout)="closeMenuOnFocusOut(i)" title="{{item.name}}">{{item.name}}</div>
            }
            @if (item.button) {
              <button class="secondary" role="menuitem" id="{{getMenuId(item)}}" title="{{item.name}}" [tabindex]="tabIndex" (click)="doCommand(i, $event)" (keyup.enter)="doCommand(i, $event)" (keydown.space)="doCommand(i, $event)" (focusout)="closeMenuOnFocusOut(i)">{{item.name}}</button>
            }
            @if (item.heading) {
              <div class="headingtext" title="{{item.name}}">{{item.name}}</div>
            }
          </div>
        </li>
      }
    </ul>
  }
}
@if (ui>=2 && !forceMenuButton) {
  @if (menuID===3) {
    <div class="menubutton" [ngClass]="{mobile:ui>=2, oai:isAddin}" (click)="toggleMenuOpen($event)" (keyup.enter)="toggleMenuOpen($event)" (keydown.space)="toggleMenuOpen($event)" (keydown.shift.tab)="closeMenuOnFocusOut(-2)">
      @if (buttonIcon) {
        <img [id]="menuId" src="{{isOpen ? buttonIconOpen : buttonIcon}}" [tabindex]="tabIndex" title = "{{toolTip}}" alt="{{toolTip}}" role="menu" [ariaLabel]="menuId==='edx_overflow_menu'?altLabels['overFlowMenu']+' '+(isOpen?altLabels['expanded']:altLabels['collapsed']):''">
      }
    </div>
  }
  @if (isOpen) {
    <div class="menu-overlay mobile" [ngClass]="{opening:isOpening, closing:isClosing, topright:drawTopRight}" (click)="overlayClick($event)"></div>
  }
  @if (isOpen) {
    <ul #ul class="mobile" [ngClass]="{opening:isOpening, closing:isClosing, topright:drawTopRight, cordova:ui>=4, ios:iOS, doaimac:officeAddinDesktopMac, oai:isAddin}" (animationend)="transitionComplete()">
      <li class="heading">
        <div class="item-container">
          <img src="{{menuIcon}}" [ngClass]="{edx_transparent:!menuIcon}">
          <div class="headingtext">{{menuTitle}}</div>
        </div>
      </li>
      @for (item of items; track item; let i = $index) {
        <li [ngClass]="{edx_hidden:!item.enabled, button:item.button, separator:item.separator}" (keyup)="onKeyUp($event,i)" (keydown.shift.tab)="onKeyUp($event,i)">
          @if (!item.separator) {
            <div class="item-container">
              @if (item.checkable) {
                <div class="checkmark" [ngClass]="{checked:item.checked, safari:safari}" (keyup.enter)="toggleCheck(i, $event)" (keydown.space)="toggleCheck(i, $event)" (click)="toggleCheck(i, $event)"></div>
              }
              @if (!item.button && !item.heading && !item.checkable) {
                <img src="{{getItemIcon(item)}}" alt="item.name" [ngClass]="{edx_transparent:!item.icon}">
              }
              @if (!item.button && !item.heading) {
                <div class="menu-text" [tabindex]="tabIndex" (keydown.space)="doCommand(i, $event)" (keyup.enter)="doCommand(i, $event)" (click)="doCommand(i, $event)" (focusout)="closeMenuOnFocusOut(i)" id="{{getMenuId(item)}}" title="{{item.name}}">{{item.name}}</div>
              }
              @if (item.button) {
                <button class="secondary mobile" [ngClass]="{oai:isAddin}" (click)="doCommand(i, $event)" id="{{getMenuId(item)}}" title="{{item.name}}">{{item.name}}</button>
              }
              @if (item.heading) {
                <div class="headingtext" title="{{item.name}}">{{item.name}}</div>
              }
            </div>
          }
        </li>
      }
    </ul>
  }
}
